import React, { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { todayISO } from "@/lib/dateHelpers";

export default function SessionNotes({ client, onAddSession }) {
  const [sessionNote, setSessionNote] = useState({ date: todayISO(), notes: "", homework: "" });

  async function handleSubmit(e) {
    e.preventDefault();
    if (!sessionNote.date || !sessionNote.notes) {
      toast.error("Date and notes are required");
      return;
    }
    const ok = await onAddSession(sessionNote);
    if (ok) setSessionNote({ date: todayISO(), notes: "", homework: "" });
  }

  return (
    <>
      <Card className="rounded-2xl shadow-sm">
        <CardContent className="space-y-4 p-6">
          <h3 className="flex items-center gap-2 text-xl font-bold">
            <CheckCircle2 size={20} /> Add Session Note
          </h3>
          <form onSubmit={handleSubmit} className="space-y-3">
            <input
              data-testid="session-date"
              type="date"
              value={sessionNote.date}
              onChange={(e) => setSessionNote({ ...sessionNote, date: e.target.value })}
              className="w-full rounded-xl border p-3"
            />
            <textarea
              data-testid="session-notes"
              placeholder="What happened in this session?"
              value={sessionNote.notes}
              onChange={(e) => setSessionNote({ ...sessionNote, notes: e.target.value })}
              className="min-h-24 w-full rounded-xl border p-3"
            />
            <textarea
              data-testid="session-homework"
              placeholder="Homework for the owner"
              value={sessionNote.homework}
              onChange={(e) => setSessionNote({ ...sessionNote, homework: e.target.value })}
              className="min-h-20 w-full rounded-xl border p-3"
            />
            <Button data-testid="save-session-btn" className="w-full rounded-2xl py-5">
              Save Session Note
            </Button>
          </form>
        </CardContent>
      </Card>
    </>
  );
}

export function SessionHistory({ client }) {
  return (
    <Card className="rounded-2xl shadow-sm">
      <CardContent className="p-6">
        <h3 className="mb-4 text-xl font-bold">Session History</h3>
        <div className="space-y-3" data-testid="session-history">
          {(client.sessions || []).map((session, index) => (
            <div
              key={`${session.date}-${index}`}
              className="rounded-2xl border border-slate-200 p-4"
            >
              <p className="font-semibold">{session.date}</p>
              <p className="mt-2 text-slate-700">{session.notes}</p>
              {session.homework && (
                <p className="mt-2 rounded-xl bg-slate-50 p-3 text-sm">
                  <span className="font-semibold">Homework:</span> {session.homework}
                </p>
              )}
            </div>
          ))}
          {(!client.sessions || client.sessions.length === 0) && (
            <p className="text-slate-500">No session notes yet.</p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
